<template>
  <article class="layout-section__container">
    <h3 class="layout-section__heading -spacing">Yoga</h3>

    <ul class="grid-icon">
      <li class="grid-icon__item">
        <svg-icon id="yoga-dog" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="yoga-warrior" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="yoga-plank" />
      </li>

      <li class="grid-icon__item">
        <svg-icon id="yoga-bend" />
      </li>
    </ul>
  </article>
</template>

<script>
export default {
  name: 'WorkIconsYoga'
}
</script>
